var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon-positive-caret-left-a",
    d: "M29.8180034,37.2078529 L55.8950817,68.2591168 C57.5570139,70.2380614 57.3168377,73.2038446 55.3586334,74.883379 C53.400429,76.5629134 50.4657285,76.3201935 48.8037964,74.3412489 L20.1048249,40.1679674 C18.6020903,38.3785872 18.6359605,35.7431357 20.1841737,33.9938006 L48.8831453,1.56666551 C50.595374,-0.367991761 53.5353223,-0.533604366 55.4497035,1.19675941 C57.3640847,2.92712318 57.5279616,5.89820978 55.8157328,7.83286705 L29.8180034,37.2078529 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00789E",
    fillRule: "nonzero",
    xlinkHref: "#icon-positive-caret-left-a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.9ff59e886dd3a18d60b780cdefdb9cff.svg";
export { ForwardRef as ReactComponent };